import { useEffect, useState } from 'react';
import { DownsellVariant, getDownsellVariant } from './getDownsellVariant';

/**
 * Resolves the downsell A/B arm for the current user.
 *
 * This only reads the local 50/50 fallback for now (see `getDownsellVariant`). The shape
 * mirrors `useMilestoneUpsellVariant`, so swapping in a real `FeaturesApi.featuresPost` call
 * with this as the fallback path is a small change once an experiment slug exists.
 */
export const useDownsellVariant = (
  userId: number | null | undefined,
  override?: DownsellVariant,
): DownsellVariant | null => {
  const [variant, setVariant] = useState<DownsellVariant | null>(override ?? null);

  useEffect(() => {
    if (override) {
      setVariant(override);
      return;
    }

    setVariant(getDownsellVariant(userId));
  }, [userId, override]);

  return variant;
};
